import {
	connect
} from 'react-redux'
import SimpleDataTable from '../components/common/SimpleDataTable.jsx';
// import {
// 	findFittingDashboard
// } from '../actions';

const mapStateToProps = (state, ownProps) => ({
	data: ownProps.data,
	fields: ownProps.fields
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	refresh: () => {
		if (ownProps.orderId) {
			// dispatch(findFittingDashboard({orderId:ownProps.orderId}));	
		}
	}
})

const FittingStatDetailCountContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(SimpleDataTable)

export default FittingStatDetailCountContainer;


// WEBPACK FOOTER //
// ./src/containers/FittingStatDetailCountContainer.jsx